
























import {
  Vue,
  AdminLte,
  Component,
  Prop,
  Watch,
  CurrentUserState
} from "division-marker";

@Component({ components: { AdminLte }, mixins: [] })
export default class WtDmLayout extends Vue {
  // get mystore(){return this.$store}
  user_menu_open = false;
  get current_user_state(): CurrentUserState {
    return this.$store.state.current_user;
  }
  get current_user() {
    return this.current_user_state.user;
  }

  get signd_in() {
    return this.current_user != null;
  }
  get is_kyoui() {
    return this.$store.getters["current_user/is_kyoui"];
  }
  get is_admin() {
    return this.signd_in && this.current_user.roles.includes("admin");
  }
  get is_saiten() {
    return this.$store.getters["current_user/is_saiten"];
  }

  async mounted() {
    const body = document.getElementsByTagName("body")[0];
    body.classList.add("skin-green-light");
  }

  registration_email() {
    this.user_menu_open = false;
    window.location.href = "./#/dm/q_registration_email";
  }
}
